import { c as _c } from "react/compiler-runtime";
import { copyTextToClipboard, useTranslation as useUiTranslation } from '@systemeio/ui';
import React from 'react';
import { Loader } from 'shared/components/loader';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { getPublicPath } from 'shared/utils/locale/get-locale-for-link';
import { LinkIcon } from '@systemeio/ui/icons';
import { formUrl } from 'shared/utils/links/form-url';
interface AffiliatePromotionLinkProps {
  affiliateId?: string;
}
const AffiliateDashboardPromotionLink = t0 => {
  const $ = _c(18);
  const {
    affiliateId
  } = t0;
  useLocoTranslation();
  const {
    t: tUi
  } = useUiTranslation();
  const {
    user
  } = useUser();
  let t1;
  if ($[0] !== affiliateId || $[1] !== user?.dashboardLocale) {
    t1 = formUrl(`${getPublicPath(user?.dashboardLocale)}?sa=${affiliateId}`, false) ?? "";
    $[0] = affiliateId;
    $[1] = user?.dashboardLocale;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const promotionLink = t1;
  const t2 = !affiliateId;
  let t3;
  if ($[3] !== promotionLink || $[4] !== tUi) {
    t3 = async e => {
      e.preventDefault();
      await copyTextToClipboard(promotionLink, tUi);
    };
    $[3] = promotionLink;
    $[4] = tUi;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== affiliateId) {
    t4 = affiliateId ? <LinkIcon className="fill-brand-primary h-[15px] w-[15px] sm:h-[20px] sm:w-[20px]" /> : <Loader small={true} />;
    $[6] = affiliateId;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
    t5 = <button disabled={t2} onClick={t3} className="border-text-secondary/30 ring-brand-primary border-r px-3 py-1 outline-hidden ring-offset-1 focus-visible:ring-2">{t4}</button>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== affiliateId || $[13] !== promotionLink) {
    t6 = affiliateId && <span className="text-brand-primary truncate px-3">{promotionLink}</span>;
    $[12] = affiliateId;
    $[13] = promotionLink;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t5 || $[16] !== t6) {
    t7 = <div className="border-text-secondary/30 bg-background-primary/50 flex max-w-full items-center rounded-lg border px-1.5 py-3">{t5}{t6}</div>;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};
export default AffiliateDashboardPromotionLink;